export default function FormSkeleton() {
  return (
    <div>
      <div className="md:w-full md:px-3 mb-6">
        <div className="h-3 bg-slate-700 rounded w-40 mb-3" />
        <div className="h-8 bg-slate-700 rounded w-full mb-6" />
      </div>

      <div className="md:w-full md:px-3 mb-6">
        <div className="h-3 bg-slate-700 rounded w-40 mb-3" />
        <div className="h-8 bg-slate-700 rounded w-full mb-6" />
      </div>

      <div className="md:w-full md:px-3 mb-6">
        <div className="h-3 bg-slate-700 rounded w-40 mb-3" />
        <div className="h-8 bg-slate-700 rounded w-full mb-6" />
      </div>

      <div className="md:w-full md:px-3 mb-6">
        <div className="h-3 bg-slate-700 rounded w-40 mb-3" />
        <div className="h-8 bg-slate-700 rounded w-full mb-6" />
      </div>

      <div className="h-8 rounded-full bg-slate-700 w-24 ml-auto " />
    </div>
  );
}
